// extracted by mini-css-extract-plugin
export default {"search":"ModalExtendedWSearch_search__jrcl3","placeHolderShimmer":"ModalExtendedWSearch_placeHolderShimmer__mldD9"};